import { MAX_ENTREGAS_POR_SAIDA } from './dominio';

// Códigos que o banco levanta (raise exception '<codigo>') e a mensagem que a pessoa vê.
// Fica no core para web e apps mostrarem exatamente o mesmo texto.

export const MENSAGENS_DE_ERRO = {
  nao_autenticado: 'Sua sessão expirou. Entre de novo.',
  so_o_dono: 'Só o dono da loja registra o pagamento do entregador.',
  acerto_imutavel: 'Este acerto não muda de entregador nem de dia. Registre no dia certo.',
  ja_tem_empresa: 'Esta conta já tem uma loja cadastrada.',
  conta_anonima: 'Para cadastrar uma loja, entre com e-mail e senha.',
  codigo_invalido: 'Código não encontrado. Confira com a loja.',
  codigo_em_uso: 'Este código já está na conta de outra pessoa. Peça à loja para trocar o código.',
  muitas_tentativas: 'Muitas tentativas. Espere 15 minutos e tente de novo.',
  entregador_nao_pareado: 'Este aparelho foi desconectado. Digite o código de novo.',
  pedido_nao_encontrado: 'Pedido não encontrado.',
  pedido_de_outro_entregador: 'Outro entregador já pegou esta entrega.',
  transicao_invalida: 'Esta entrega mudou de situação. Atualize a lista.',
  avaliacao_invalida: 'Escolha de 1 a 5 estrelas.',
  pedido_ja_saiu: 'Este pedido já saiu para entrega: não dá para trocar o entregador.',
  entrega_a_caminho: 'Termine ou devolva a entrega a caminho antes.',
  loja_invalida: 'Esta loja não está mais disponível para você.',
  perfil_incompleto: 'Complete seu nome e WhatsApp antes.',
  saida_grande_demais: `Saia com até ${MAX_ENTREGAS_POR_SAIDA} entregas de cada vez.`,
  so_o_dono_marca_a_loja: 'Só o dono da loja marca onde ela fica.',
  local_invalido: 'Este local não parece certo. Tente de novo.',
  local_impreciso: 'A localização veio imprecisa. Tente pelo celular, de dentro da loja.',
  local_longe_da_loja: 'Este ponto fica longe demais da loja.',
  porta_vencida: 'Passou o prazo para gravar onde esta entrega foi feita.',
  porta_na_loja: 'Este ponto é a loja, não o endereço do cliente.',
  porta_longe_do_destino: 'Este ponto fica longe do endereço desta entrega.',
  entregador_obrigatorio: 'Escolha o entregador antes de marcar a saída.',
  motivo_obrigatorio: 'Conte o motivo.',
  acao_invalida: 'Ação inválida.',
  empresa_divergente: 'Dados de outra loja não podem ser usados aqui.',
  endereco_de_outro_cliente: 'Este endereço é de outro cliente.',
  telefone_duplicado: 'Já existe um cliente com este telefone.',
  pagamento_invalido: 'Confira as formas de pagamento.',
  pagamento_nao_fecha: 'As formas de pagamento não fecham o total do pedido.',
  troco_sem_dinheiro: 'Troco só quando parte do pagamento é em dinheiro.',
  troco_menor: 'A nota do troco precisa cobrir a parte em dinheiro.',
  nao_da_para_desfazer: 'Não deu para desfazer: o pedido já mudou. Confira na lista.',
  apelido_repetido: 'Este apelido já é de outro produto.',
  produto_invalido: 'Confira o nome, o preço e os apelidos.',
  produto_repetido: 'Já existe um produto com este nome.',
  logo_invalida: 'Esta imagem não serve como logo. Use PNG, JPG, WebP ou SVG.',
  sem_permissao: 'Só o dono da loja altera isto.',
  sem_conexao: 'Sem conexão. Confira a internet e tente de novo.',
  desconhecido: 'Algo deu errado. Tente de novo.',
} as const;

export type CodigoErro = keyof typeof MENSAGENS_DE_ERRO;

export function ehCodigoErro(valor: string): valor is CodigoErro {
  return Object.hasOwn(MENSAGENS_DE_ERRO, valor);
}

export function mensagemDeErro(codigo: CodigoErro): string {
  return MENSAGENS_DE_ERRO[codigo];
}
